<div>
  <mat-icon style="color: #ff1000;">cancel</mat-icon>
  <span style="color: #ff1000;">{{messageService.message.message}}</span>
</div>
